module.exports = __webpack_public_path__ + "static/media/utp-letterhead-bw-restricted.c26580a4.png";